import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2018895d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-weight": "700",
    "font-size": "24px"
  }
}, "支付平台租户信息", -1));
const _hoisted_3 = {
  class: "tenant-info-box"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "header",
  style: {
    "margin-bottom": "5rpx"
  }
};
const _hoisted_6 = {
  class: "body"
};
const _hoisted_7 = {
  class: "description-content"
};
const _hoisted_8 = {
  class: "description-content"
};
const _hoisted_9 = {
  class: "description-content"
};
import { onMounted, ref } from 'vue';
import { getPaymentById } from '@/api/payment';
import { useRoute } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const {
      id
    } = route.params;
    const payTenantMessage = ref({});
    const getPayTenantData = async () => {
      const res = await getPaymentById(id);
      payTenantMessage.value = res;
      console.log(payTenantMessage.value);
    };
    onMounted(() => {
      getPayTenantData();
    });
    return (_ctx, _cache) => {
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", _hoisted_4, _toDisplayString(`${payTenantMessage.value.name}支付平台飞租户信息`), 1), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_descriptions, {
          column: 3,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "企业名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.name), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "租户id"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.id), 1)]),
            _: 1
          }), payTenantMessage.value.platform === 'p2' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
            key: 0,
            label: "应用id"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.appId), 1)]),
            _: 1
          })) : _createCommentVNode("", true), payTenantMessage.value.platform === 'p2' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
            key: 1,
            label: "终端编号"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.terminalId), 1)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
            label: payTenantMessage.value.platform === 'p1' ? '服务商编号' : '机构号'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.keyId), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
            label: payTenantMessage.value.platform === 'p1' ? '商户id' : '商户号'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.mchId), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
            label: "应用所属平台"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.platform === 'p1' ? '华夏银行' : '兴业银行'), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "创建时间"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.createTime), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "状态"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(payTenantMessage.value.statusName), 1)]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_descriptions, {
          direction: "vertical",
          column: 1,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: payTenantMessage.value.platform === 'p1' ? '商户私钥' : '签名私钥',
            width: "50%",
            "class-name": "description-item-class"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(payTenantMessage.value.privateKey), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
            label: payTenantMessage.value.platform === 'p1' ? '服务公钥' : '响应报文验签公钥'
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(payTenantMessage.value.privateKey), 1)]),
            _: 1
          }, 8, ["label"]), payTenantMessage.value.platform === 'p2' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
            key: 0,
            label: "字段加密密钥"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, _toDisplayString(payTenantMessage.value.encryptKey), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })])])]),
        _: 1
      })]);
    };
  }
};